// extracted by mini-css-extract-plugin
export default {"rating":"oK-z","numberOfStars":"pK-z","count":"qK-z","barGraphSpacing":"rK-z","barGraph":"sK-z"};